import React from 'react';
import '../styling/dashboard.css';
import NavBar from '../components/navBar';
import IndividualGameTile from '../components/IndividualGameTile';
import SideBar from '../components/sidebar';
import GameDisplayPage from './GameDisplayPage';
import {getGameData} from '../components/utilities'
import { UserContext } from '../contexts/UserContext';

class Dashboard extends React.Component{

	static contextType = UserContext

	state = {
		currentGame: "",
		data: null
	}

	gameChosenEvent = (event, name) => {
		event.preventDefault();
		this.setState({...this.state, currentGame: name})
	}

	lastGame = "";

	componentDidUpdate = async () => {

		if(this.state.currentGame == "") {
			return;
		}
		if(this.lastGame != "") {
			return;
		}
		this.lastGame = this.state.currentGame;
		// console.log("USer data", this.context.userData.)
		//const data = await getGameData(this.state.currentGame, this.context.userData.twitter_id);
		console.log()

		// this.setState({...this.state, data: data})
		console.log("Loaded data.")
	}

    render(){
        return(

            <div className="Dashboard">
                <NavBar/>
                <SideBar/>

                <IndividualGameTile gameChosen={this.gameChosenEvent}/>
            </div>
        ) 
    }


}




export default Dashboard;